import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { PersonType } from '../models/enums';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalServiceService {
  chart$ = new EventEmitter<any>();
  chartAll$ = new EventEmitter<any>();
  chartDestroy$ = new EventEmitter<any>();

  portfolioTypeSubject = new BehaviorSubject<string>('');
  portfolioReloadSubject = new BehaviorSubject<boolean>(false);

  personType: string = PersonType.COMPANY;
  alertPY: boolean = false;
  role: boolean = true;
  nameModelIndicator: string = $localize`Resumen de indicadores`;
  orderSelected: number = 0;

  private readonly currentPersonType$ = new BehaviorSubject<PersonType>(PersonType.COMPANY); // TEMP-COMPANY-DEFAULT
  private readonly documentAdded$ = new Subject();
  private readonly walletAdded$ = new Subject();

  constructor(private readonly localStorageService: LocalStorageService) {}

  setWalletAdded() {
    this.walletAdded$.next(true);
  }

  getWalletAdded$() {
    return this.walletAdded$.asObservable();
  }

  setDocumentAdded() {
    this.documentAdded$.next(true);
  }

  getDocumentAdded$() {
    return this.documentAdded$.asObservable();
  }

  getPersonType$() {
    return this.currentPersonType$.asObservable();
  }

  getPersonTypeCurrentValue() {
    return this.currentPersonType$.getValue();
  }

  setPersonType(personType: PersonType) {
    this.localStorageService.setItem('personType', personType);
    this.currentPersonType$.next(personType);
  }
}
